import React from 'react';
import { motion } from 'framer-motion';
const painPoints = [{
  emoji: '🥦',
  text: 'Querés comer más vegetal pero siempre terminás haciendo lo mismo (arroz con algo)'
}, {
  emoji: '😩',
  text: 'Abrís la heladera, ves verduras y no sabés qué cocinar'
}, {
  emoji: '💸',
  text: 'Pensás que comer vegano es caro, complicado o con ingredientes que no conseguís en el súper'
}, {
  emoji: '🍽️',
  text: "Cocinás algo 'sano' pero queda desabrido y sin gracia... y terminás pidiendo delivery"
}, {
  emoji: '👨‍👩‍👧',
  text: 'A tu familia no le gusta lo vegano y no sabés cómo convencerlos'
}, {
  emoji: '😰',
  text: 'No sabés si estás comiendo bien: te preocupa la proteína, el hierro, la energía'
}];
export function PainPoints() {
  return <section className="bg-[#18181b] py-12 px-4" data-id="element-102">
      <div className="max-w-4xl mx-auto" data-id="element-103">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8" data-id="element-104">
          <h2 className="text-3xl md:text-4xl font-bold text-white" data-id="element-105">
            ¿Te pasa alguna de estas cosas?
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-8" data-id="element-106">
          {painPoints.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.08
        }} className="bg-[#0a0a0a] border border-zinc-800 rounded-lg p-4 flex items-start gap-3 hover:border-emerald-900 transition-colors" data-id="element-107">
              <span className="text-2xl flex-shrink-0" data-id="element-108">{point.emoji}</span>
              <p className="text-zinc-300 text-sm leading-relaxed" data-id="element-109">
                {point.text}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4
      }} className="bg-emerald-950/30 border border-emerald-900/50 rounded-xl p-6 text-center" data-id="element-110">
          <p className="text-lg md:text-xl font-medium text-emerald-400" data-id="element-111">
            El problema no sos vos. Es que nadie te dio un sistema visual,
            práctico y diseñado para la cocina argentina.
          </p>
        </motion.div>
      </div>
    </section>;
}